/**
 * Raw 1-based color palette (Figma Gray 1-8, 그 외 1-9).
 *
 * @see https://www.figma.com/design/t8VINTS1iMOuGc9YmmFyxI/-JANGBOO--%EC%8A%A4%ED%8C%AC%EB%94%A7-UI-%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC?node-id=348-25&m=dev
 *
 */
import type { ValueOf } from '@/types';

const colors = {
  gray: {
    1: '#FFFFFF',
    2: '#F8F8F8',
    3: '#EEEEEE',
    4: '#DCDCDC',
    5: '#BDBDBD',
    6: '#989898',
    7: '#6B6B6B',
    8: '#212121',
  },
  red: {
    1: '#FFF6F5',
    2: '#FEE8E7',
    3: '#FFCABB',
    4: '#FFA68F',
    5: '#F56141',
    6: '#D50000',
    7: '#C00000',
    8: '#9F1701',
    9: '#780D01',
  },
  yellow: {
    1: '#FFFDE5',
    2: '#FFFAC1',
    3: '#FEF697',
    4: '#FDF16B',
    5: '#FFDC1C',
    6: '#FFAB00',
    7: '#FF9712',
    8: '#FE7F00',
    9: '#EE5A00',
  },
  green: {
    1: '#F6FFF8',
    2: '#E6F8EA',
    3: '#C4EDCC',
    4: '#70D788',
    5: '#00C351',
    6: '#00A03B',
    7: '#006F18',
    8: '#015613',
    9: '#054310',
  },
  cyan: {
    1: '#EAFFFF',
    2: '#B4F0F0',
    3: '#83E3E4',
    4: '#51D6DB',
    5: '#00C4D0',
    6: '#00B2BD',
    7: '#018E90',
    8: '#00736E',
    9: '#00574F',
  },
  blue: {
    1: '#F2F9FF',
    2: '#E4F3FF',
    3: '#BFE1FF',
    4: '#96CEFF',
    5: '#4EABFF',
    6: '#3C8EFF',
    7: '#3A7AEB',
    8: '#3968D8',
    9: '#3548B8',
  },
  magenta: {
    1: '#FFF8FE',
    2: '#F6E4F3',
    3: '#E9BAE3',
    4: '#DB8CD1',
    5: '#CB5BBE',
    6: '#BF2FB1',
    7: '#8A0092',
    8: '#6F0275',
    9: '#540067',
  },
  navy: {
    1: '#F6F7F9',
    2: '#E5E9F0',
    3: '#BDC9DA',
    4: '#93A6C1',
    5: '#6A84A9',
    6: '#486A98',
    7: '#20528A',
    8: '#04386A',
    9: '#0D2852',
  },
  purple: {
    1: '#FAF8FB',
    2: '#F1E8F7',
    3: '#DECDEF',
    4: '#C5A7E2',
    5: '#A978D3',
    6: '#9D5AD0',
    7: '#8D3CCC',
    8: '#741ECD',
    9: '#6414BB',
  },
} as const;

export const BACKGROUND_COLOR = '#FDFDFD';

export type ColorKeysWithoutGray = Exclude<keyof typeof colors, 'gray'>;

type ThemePaletteHexColorMap = {
  [K in keyof typeof colors]: ValueOf<(typeof colors)[K]>;
};

type ThemePaletteHexColor = ValueOf<ThemePaletteHexColorMap>;
export type Colors = ThemePaletteHexColor | typeof BACKGROUND_COLOR;

export default colors;
